var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-5 items-center mt-5"},[_c('IconComponent',{staticClass:"!text-4xl text-gray-300",attrs:{"icon":"empty-set"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }